<template>
  <div :class="cn(props.class)">
    <div class="bg-background z-2 sticky top-0 flex h-12 items-center justify-center border-b p-2">
      <h3 class="text-sm font-medium">{{ policy.fundShortText }}</h3>

      <UiDialogClose>
        <UiButton :class="cn('absolute start-0 top-0 h-12 w-12 p-0')" variant="icon">
          <LucideChevronLeft class="size-5 -translate-x-0.5 rtl:rotate-180" />
        </UiButton>
      </UiDialogClose>
    </div>

    <PensionPortfolioScreen :policy :category />
  </div>
</template>

<script setup lang="ts">
import { LucideChevronLeft } from "lucide-vue-next"

import { OverviewScreenProps } from "./OverviewTypes/Shared"

const props = defineProps<OverviewScreenProps>()
</script>
